import { DesignListCard, ProjectIcon } from '@cfs-fixings/shared'
import { DesignResource, ProjectWithOrderedDesignsResource } from '@/api/serverApi'
import { Link, useNavigate } from 'react-router-dom'
import Button from '@cfs-fixings/shared/src/components/button'

type PropTypes = {
  projects?: ProjectWithOrderedDesignsResource[]
  footerElements?: React.ReactNode[]
  dropdown?: (design: DesignResource) => React.ReactNode
}

function GroupedDesignListView ({ projects, footerElements, dropdown }: PropTypes) {
  const navigate = useNavigate()

  return (
    <ul className="w-full">
      {
        projects?.map((project) => (
          <li key={project.id} className="mb-10">
            <div className="flex flex-row items-center gap-[5px] mb-[23px] px-2.5">
              <ProjectIcon className="h-[18px] w-[18px]" />
              <p className="font-semibold leading-[19.2px]">{project.name}</p>
            </div>
            <ul>
              {
                project.designs.map((design) => (
                  <li
                    key={design.id}
                    className="px-2.5 hover:bg-gray-50 [&>div]:last-of-type:border-b-0"
                  >
                    <div className="border-b-gray-100 border-b">
                      <Link
                        to={`/designs/${design.id}`}
                      >
                        <DesignListCard design={design} dropdown={dropdown?.(design)} />
                      </Link>
                    </div>
                  </li>
                ))
              }
              {
                project.has_more_designs
                  && <div className="flex items-center justify-center mt-4">
                    <Button
                      variant={'secondary'}
                      onClick={() => navigate(`/projects/${project.id}`)}
                    >
                      See More
                    </Button>
                  </div>
              }
            </ul>
          </li>
        ))
      }
      {
        ...(footerElements ?? [])
      }
    </ul>
  )
}

export default GroupedDesignListView
